"use client";

import styled, { css } from "styled-components";

type BoxProps = {
  $status: "connected" | "checking" | "disconnected" | "generateQR" | "qrCode";
};

export const Box = styled.div<BoxProps>`
  padding: 15px;
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 3px solid;
  border-radius: 15px;

  ${({ $status }) =>
    $status === "connected" &&
    css`
      border-color: var(--successSystem);

      svg {
        stroke: var(--successSystem);
      }
    `}

  ${({ $status }) =>
    $status === "checking" &&
    css`
      border-color: var(--primarySystem100);

      svg {
        stroke: var(--primarySystem100);
      }
    `}

    ${({ $status }) =>
    $status === "disconnected" &&
    css`
      border-color: var(--infoSystem);

      svg {
        stroke: var(--infoSystem);
      }
    `}

    ${({ $status }) =>
    ($status === "generateQR" || $status === "qrCode") &&
    css`
      border-color: var(--borderColor);

      svg {
        stroke: var(--textLight);
      }
    `}

    svg {
    width: 50px;
    height: 50px;
    margin-bottom: 10px;
  }
`;

export const BoxQRCode = styled.div`
  display: flex;
  aling-items: center;
  justify-content: center;
`;

export const Description = styled.div`
  font-family: "Inter Medium";
  font-size: 20px;
  color: var(--textLight);
  text-align: center;
`;
